import { Router, type CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { inject } from '@angular/core';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // console.log('guard route',route)
  // console.log('guard state',state)
  
  if (authService.isAuthentticated()) {
    return true;
  } else {
    router.navigate(['/login']);
    return false;
  }
};
